
import { defineComponent } from "vue";

import PropsCatalogue from "@/components/catalogues/PropsCatalogue/PropsCatalogue.vue";

export default defineComponent({
  components: { PropsCatalogue },
  props: {},
  methods: {},
  data() {
    return {};
  },
});
